// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VXzwXO{color:var(--backgroundColor);background-color:#f64d43}.TtSP2o{color:var(--backgroundColor);background-color:#008250}.felL8e{display:flex;align-items:center;justify-content:center;position:absolute;left:0;top:0;width:100%;padding:17px 35px;box-sizing:border-box;text-align:center}.vHTsfg{position:absolute;left:0;top:0;width:100%;height:100%;display:flex;z-index:2}.vHTsfg.hC9iuP,.vHTsfg.PeDFJr{background:"opacity(color(--defaultColor), .75)"}.vHTsfg.qALcIm{background:"opacity(color(--backgroundColor), .75)";color:"color(--defaultColor)"}.vHTsfg.qALcIm{position:fixed}.vHTsfg.hC9iuP{z-index:3}.vHTsfg.jSoKlR{align-items:center;justify-content:center;flex-direction:column}.Dvn6KF{position:absolute;right:5px;top:10px;width:12px;height:12px}.Dvn6KF:hover{cursor:pointer}.Dvn6KF:before,.Dvn6KF:after{content:' ';position:absolute;left:0px;height:12px;width:1px;background-color:var(--backgroundColor)}.Dvn6KF:before{transform:rotate(45deg)}.Dvn6KF:after{transform:rotate(-45deg)}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorStatus": `VXzwXO`,
	"successStatus": `TtSP2o`,
	"toast": `felL8e`,
	"removalOverlay": `vHTsfg`,
	"error": `hC9iuP`,
	"loading": `PeDFJr`,
	"mobile": `qALcIm`,
	"center": `jSoKlR`,
	"cross": `Dvn6KF`
};
export default ___CSS_LOADER_EXPORT___;
